module.exports = __webpack_public_path__ + "static/media/switzerland.9c26f60a.svg";